export const sessionStorageKey = {
  rewardInfo: 'REWARD_INFO',
  lastPageArtistFristPathname: 'LAST_PAGE_ARTIST_FRIST_PATHNAME',
} as const
